import './AgenticAiHero.css';
import { Link, useLocation } from 'react-router-dom';

export default function AgenticAiHero() {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const niveau = searchParams.get('niveau');

	const showLevelTabs = niveau === 'niveau1' || niveau === 'niveau2';

	const pathname = location.pathname;

	const pageTitle = pathname.includes('/formations/it-sales')
		? 'IT Sales'
		: 'Agentic AI';
	return (
		<section className='agentic-ai-hero'>
			<div className='agentic-ai-hero__shape agentic-ai-hero__shape--dots' />
			<div className='agentic-ai-hero__shape agentic-ai-hero__shape--lines' />

			<div className='agentic-ai-hero__inner'>
				<h1 className='agentic-ai-hero__title'>{pageTitle}</h1>
				{showLevelTabs ? (
					<div className='agentic-ai-hero__levels'>
						<Link
							to={`${pathname}?niveau=niveau1`}
							className={`agentic-ai-hero__level-link ${
								niveau === 'niveau1'
									? 'agentic-ai-hero__level-link--active'
									: ''
							}`}>
							Niveau 1
						</Link>

						<Link
							to={`${pathname}?niveau=niveau2`}
							className={`agentic-ai-hero__level-link ${
								niveau === 'niveau2'
									? 'agentic-ai-hero__level-link--active'
									: ''
							}`}>
							Niveau 2
						</Link>
					</div>
				) : (
					<div className='agentic-ai-hero__breadcrumb'>
						<Link to='/'>Home</Link>
						<span>/</span>
						<span>Agentic Ai</span>
					</div>
				)}
			</div>
		</section>
	);
}
